import IpCheckPage from './components/IpCheckPage';

export { IpCheckPage };
